module.exports = __webpack_public_path__ + "static/media/deselect.71395383.svg";